import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "src/componentes";
import {
  UsuarioConfirmarEmail,
  UsuarioEnviarConfirmacaoEmail,
} from "src/services/Identity.Service";

export const ConfirmarEmailCode = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState<string>("");
  const [codigo, setCodigo] = useState<string>("");
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [resending, setResending] = useState<boolean>(false);
  const [timeLeft, setTimeLeft] = useState<number>(180); // 3 minutos = 180s
  const [timerKey, setTimerKey] = useState<number>(0);

  useEffect(() => {
    const stateEmail =
      location.state?.email || sessionStorage.getItem("confirmar_email");
    if (stateEmail) {
      setEmail(stateEmail);
      sessionStorage.setItem("confirmar_email", stateEmail);
    } else {
      navigate("/login");
    }
  }, [location.state, navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timerKey]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      showToast({
        message: "Por favor, digite seu e-mail.",
        title: "Aviso",
        variant: "Warning",
      });
      return;
    }

    if (!codigo || codigo.length !== 6) {
      showToast({
        message: "Por favor, insira o código de 6 dígitos.",
        title: "Aviso",
        variant: "Warning",
      });
      return;
    }

    setSubmitting(true);
    try {
      const response = await UsuarioConfirmarEmail(email, codigo);
      if (response.success) {
        sessionStorage.removeItem("confirmar_email");
        showToast({
          message: "E-mail confirmado com sucesso! Faça seu login.",
          variant: "Success",
        });
        navigate("/login");
      } else {
        showToast({
          message: response.notifications[0]?.message || "Código inválido ou expirado.",
          title: "Erro",
          variant: "Warning",
        });
      }
    } catch (error) {
      console.error("Erro ao confirmar e-mail:", error);
      showToast({
        message: "Ocorreu um erro ao verificar o código.",
        title: "Erro",
        variant: "Warning",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleResend = async () => {
    if (resending) return;
    if (!email) {
      showToast({
        message: "Por favor, informe seu e-mail para reenviar.",
        title: "Aviso",
        variant: "Warning",
      });
      return;
    }

    setResending(true);
    try {
      const response = await UsuarioEnviarConfirmacaoEmail({ email } as any);
      if (response.success) {
        showToast({
          message: "Novo código de confirmação enviado para o e-mail!",
          variant: "Info",
        });
        setTimeLeft(180);
        setTimerKey((prev) => prev + 1);
        setCodigo("");
      } else {
        showToast({
          message: response.notifications[0]?.message || "Erro ao reenviar o e-mail.",
          title: "Erro",
          variant: "Warning",
        });
      }
    } catch (error) {
      console.error("Erro ao reenviar e-mail:", error);
      showToast({
        message: "Ocorreu um erro ao reenviar o e-mail.",
        title: "Erro",
        variant: "Warning",
      });
    } finally {
      setResending(false);
    }
  };

  const onClickNavigate = (route: string) => () => {
    navigate(route);
  };

  return {
    email,
    setEmail,
    codigo,
    setCodigo,
    submitting,
    resending,
    timeLeft,
    formatTime,
    onSubmit,
    handleResend,
    onClickNavigate,
  };
};
